import React from 'react'
import { truncate } from 'lodash'
import CopytoClipboard from '../../common/CopyToClipboard'

type Props = {
  quoteId: string,
  groupId: string,
  showQuote: boolean
}

const ScenarioInfo: React.FC<Props> = ({ quoteId, groupId, showQuote }) => {
  return (
    <div className="box flex-box buffer-bottom--sm">
      <div className="flex-box__item">
        {showQuote
          && (
            <>
              <span className="buffer-right">
                Quote ID: <strong>{quoteId}</strong>
                <CopytoClipboard size={20} string={quoteId} />
              </span>

              <span>
                Group ID: <strong>{groupId}</strong>
                <CopytoClipboard size={20} string={groupId} />
              </span>
            </>
          )}
      </div>

      <div className="flex-box__item flex-box__item--fixed flex-box__item--right">
        <span title={window.location.href}>
          Scenario URL: <strong>{truncate(window.location.href)}</strong>
          <CopytoClipboard size={20} string={window.location.href} />
        </span>
      </div>
    </div>
  )
}

export default ScenarioInfo
